import type { LeadingFilterGroup } from '~/ui-rocco/pages/directory-browse/DirectoryFilterSidebar';
import {
    ARTICLE_ORDERS,
    DEFAULT_ARTICLE_ORDER,
    ORDER_PARAM,
    validateArticleOrder,
} from '@modules-rocco/articles/config/article-facets';

/**
 * The listing's order, as a group in the refine drawer.
 *
 * Rendered as links rather than through the shared sort dropdown for two
 * reasons: revamp browse holds the shared sort dropdown back until the
 * directory sort lists gain a relevance option, and this listing's two orders
 * are the only two its query supports — so the drawer states them plainly
 * instead of borrowing a control built for the search-service directories.
 *
 * Each option is a real URL, so the order is shareable and survives a refresh.
 */
export const buildOrderGroup = (
    pathname: string,
    search: string,
): LeadingFilterGroup => {
    const params = new URLSearchParams(search);
    const current = validateArticleOrder(params.get(ORDER_PARAM));

    return {
        title: 'Sort',
        defaultOpen: true,
        singleChoice: true,
        items: ARTICLE_ORDERS.map((order) => {
            const next = new URLSearchParams(search);
            // The standing order is the absence of the param, so choosing it
            // writes a clean URL rather than one pinned to today's default.
            if (order.value === DEFAULT_ARTICLE_ORDER) {
                next.delete(ORDER_PARAM);
            } else {
                next.set(ORDER_PARAM, order.value);
            }
            // A new order re-ranks the whole set, so holding a page number
            // would drop the reader into the middle of a listing they have
            // not seen the start of.
            next.delete('page');
            const query = next.toString();

            return {
                id: order.value,
                label: order.label,
                checked: order.value === current,
                to: `${pathname}${query ? `?${query}` : ''}`,
            };
        }),
    };
};
